var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-modal-frame",
    {
      attrs: { "is-showing": _vm.isShowing, "has-actions": "" },
      on: { "close-modal": _vm.closeModal },
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _c(
          "section",
          {
            staticStyle: {
              "margin-inline": "calc(-1 * var(--card-horizontal-padding))",
              "margin-top": "calc(-1 * var(--card-vertical-padding))",
              "border-radius":
                "var(--card-border-radius) var(--card-border-radius) 0 0",
              overflow: "hidden",
            },
          },
          [
            _c("img", {
              staticStyle: {
                width: "100%",
                height: "100%",
                "object-fit": "cover",
              },
              attrs: {
                src: "/images/icons/packs/utility/utility-thumb.svg",
                alt: "Utility Icon Pack",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("section", { staticClass: "text-left" }, [
          _c("h2", { staticClass: "margin-top-sm margin-bottom-2xs" }, [
            _vm._v("Introducing: Utility!"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "margin-bottom-md" }, [
            _vm._v(
              "\n        Our newest Pro+ icon pack is here and ready to work. With a Bauhaus-inspired blend of sharp corners and smooth curves, this pack fits seamlessly into any\n        project and gets the job done.\n      "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("Limited-time offer:")]),
            _vm._v(" Get 20% off your first year of Pro+ with code "),
            _c("strong", [_vm._v("UTILITY")]),
            _vm._v("."),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "display-flex flex-column flex-items-center tablet:flex-row tablet:flex-content-between",
          staticStyle: {
            "--button-margin-bottom": "0",
            gap: "var(--spacing-md)",
          },
          attrs: { slot: "actions" },
          slot: "actions",
        },
        [
          _c(
            "site-link",
            {
              staticClass: "button block",
              attrs: { to: _vm.$pack({ name: "utility" }) },
            },
            [_vm._v("Explore Utility")]
          ),
          _vm._v(" "),
          _c(
            "site-link",
            {
              staticClass: "button block teal",
              attrs: {
                to: { name: "plans.pro-plus", query: { discount: "UTILITY" } },
              },
            },
            [_vm._v("Get 20% Off Pro+")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }